import { env } from 'mutants-microfx';
var constant = env.constant, platform = env.platform;
var tools = /** @class */ (function () {
    function tools() {
    }
    tools.isJsonStr = function (jsonStr) {
        if (this.isNull(jsonStr)) {
            return false;
        }
        if (jsonStr.indexOf('{') == 0 || jsonStr.indexOf('[') == 0) {
            return true;
        }
    };
    //去空函数
    tools.trim = function (str) {
        var localstr = new String(str);
        var pattern = /^\s+|\s+$/g;
        localstr = localstr.replace(pattern, "");
        return localstr.toString();
    };
    //判断是否为空
    tools.isNull = function (s) {
        if (s == undefined || (this.trim(s) + "123" == "123")) {
            return true;
        }
        return false;
    };
    //判断数组是否包含
    tools.arrayContains = function (array, element) {
        if (!array) {
            return false;
        }
        for (var i = 0; i < array.length; i++) {
            if (array[i] == element) {
                return true;
            }
        }
        return false;
    };
    //获取location search参数
    tools.GetQueryString = function (locationSearch, name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = locationSearch.substr(1).match(reg);
        if (r != null)
            return (r[2]);
        return null;
    };
    /**
     * 获取当前时间
     * @return 返回时间类型 yyyy-MM-dd HH:mm:ss
     */
    tools.sysTime = function () {
        var myDate = new Date();
        var year = myDate.getFullYear();
        var month = myDate.getMonth() + 1;
        var date = myDate.getDate();
        var h = myDate.getHours();
        var m = myDate.getMinutes();
        var s = myDate.getSeconds();
        var now = year + '-' + this.getMakeZero(month) + "-" + this.getMakeZero(date) + " " + this.getMakeZero(h) + ':' + this.getMakeZero(m) + ":" + this.getMakeZero(s);
        return now;
    };
    /**
     *  时间补0
     *
     * @return 返回时间类型 yyyy-MM-dd HH:mm:ss
     */
    tools.getMakeZero = function (s) {
        return s < 10 ? '0' + s : s;
    };
    tools.isApp = function () {
        return platform == constant.platform.yonyou || platform == constant.platform.chanjet;
    };
    return tools;
}());
export default tools;

//# sourceMappingURL=tools.js.map
